import React, { Component } from "react";
import { createContext } from "react";
// import { createContext } from "preact-context"

import axios from "axios";
import { parseJwt, refreshToken } from "../common/utils";
import {
  LOCAL_API,
  CLIENT_TOKEN,
  API_URL,
  CONTACT_USER_ENDPOINT,
  CONTACT_ENDPOINT,
  REFRESH_TOKEN_EXPIRED_ERROR,
  timeRanges,
  activitiesNotIncludedInClassEvents,
  CLUB_ID,
  CLUB_CODE,
  MONSTADE_CHECKOUT_ID,
  DEFAULT_HEADERS,
} from "../common/constants";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import weekday from "dayjs/plugin/weekday";
import Api from "../common/helpers/Api";
dayjs.Ls.fr.weekStart = 1;
dayjs.locale("fr");
dayjs.extend(weekday);
export const Context = createContext({
  //loading
  loading: {
    mandates: false,
  },
  //popups
  popupBuyCoursCollectif: false,
  popupBuyFreeTraining: false,
  popupBookSingleActivity: false,
  popupBasket: false,
  popupSlotBooking: false,
  popupCustomProgram: false,
  togglePopup: () => {},

  // Information de connexion utilisateur
  isLoggedIn: false,

  contactUser: null,
  contact: null,
  getLoginStatus: () => {},
  setLoginStatus: () => {},
  isUserLoggedIn: () => {},
  getContactFromUser: () => {},
  getContact: () => {},
  mandates: null,
  getMandates: () => {},
  // Planning
  dateRange: dayjs(),
  calendars: [],
  setCalendars: () => {},
  setCurrentReservationId: () => {},
  currentReservationId: null,
  //remote rules
  customProgramRules: undefined,
  combinationProductRules: undefined,
});

class Provider extends Component {
  state = {
    //Loading
    loading: {
      mandates: false,
    },

    // Basket
    popupOpened: false,
    togglePopup: (popUpName, isOpened) =>
      this.setState({ [popUpName]: isOpened }),

    // Information de connexion utilisateur
    isLoggedIn: false,

    contactUser: null,
    contact: null,

    logout: async () => {
      localStorage.removeItem("ACCESS_TOKEN");
      localStorage.removeItem("REFRESH_TOKEN");
      localStorage.removeItem("IS_LOGGED_IN");
      localStorage.removeItem("CONTACT");
      localStorage.removeItem("CONTACT_USER");
      // this.setState({ contact: null, contactUser: null, isLoggedIn: false });

      // on enlève le cookie avec le nom du user dans le bouton accès adhérent
      document.cookie = `account-button=;  expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    },

    getLoginStatus: async () => {
      console.log("will get Login status");
      const jwt = await localStorage.getItem("ACCESS_TOKEN");
      // const tokenRefresh = await localStorage.getItem("REFRESH_TOKEN");

      if (jwt) {
        console.log("there is a JWT In storage");
        const jwtDecoded = parseJwt(jwt);
        const currentTime = new Date().getTime() / 1000;
        if (currentTime > jwtDecoded.exp) {
          /* expired */
          console.log("expired");
          this.state.setLoginStatus(false);

          // if (tokenRefresh) {
          //   console.log("refresh token available");
          //   const res = await refreshToken(tokenRefresh);
          //   console.log("reees du refresh", res);
          //   if (res.error === REFRESH_TOKEN_EXPIRED_ERROR) {
          //     console.log("will set loginStatus to False");
          //     this.state.setLoginStatus(false);
          //   }
          //   else if (res.status === "ok"){
          //     this.state.setLoginStatus(true);
          //   }
          // }
        } else {
          // valid token (not expired)
          const contactUser = await JSON.parse(
            localStorage.getItem("CONTACT_USER")
          );
          const contact = await JSON.parse(localStorage.getItem("CONTACT"));
          console.log("valid token");
          if (!contact && !contactUser) {
            await this.state.getContactFromUser(jwtDecoded.userId);
            if (this.state.contactUser) {
              await this.state.getContact();
            }
            this.state.setLoginStatus(true);
          } else {
            console.log(
              "we have a contact and a contact User from storage",
              contact
            );
            await this.setState({ contactUser, contact });
            this.state.setLoginStatus(true);
          }
        }
      }

      // else if (tokenRefresh) {
      //   console.log("there is a Refresh token In storage");
      //   const res = await refreshToken(tokenRefresh);
      //   if(res.status === "ok"){
      //     const contact = await localStorage.getItem("CONTACT");
      //     const contactUser = await localStorage.getItem("CONTACT_USER");
      //     this.setState({contact: JSON.parse(contact), contactUser: JSON.parse(contactUser)})
      //     this.state.setLoginStatus(true);
      //   }
      // }
      else {
        console.log("seems like there is no token in  storage");
        this.state.setLoginStatus(false);
      }
    },

    getLoginStatusFromStorage: async () => {
      const jwt = await localStorage.getItem("ACCESS_TOKEN");
      // const tokenRefresh = await localStorage.getItem("REFRESH_TOKEN");

      if (jwt) {
        const jwtDecoded = parseJwt(jwt);
        const currentTime = new Date().getTime() / 1000;
        if (currentTime > jwtDecoded.exp) {
          /* expired */
          console.log("expired");
          this.setState({ isLoggedIn: false });
        } else {
          this.setState({ isLoggedIn: true });
          return true;
        }
      } else {
        this.setState({ isLoggedIn: false });
      }
      return false;
    },
    setLoginStatus: async (isLoggedIn, token = null) => {
      localStorage.setItem("IS_LOGGED_IN", true);
      if (isLoggedIn && token) {
        const jwtDecoded = await parseJwt(token);
        console.log("inside if", jwtDecoded.userId);
        // TODO avoid calling to many setState
        await this.state.getContactFromUser(jwtDecoded.userId);
        await this.state.getContact();
        await this.setState({ isLoggedIn });
        // Cookie pour le bouton "Accès adhérent"
        const expirationCookie = new Date(0);
        expirationCookie.setUTCSeconds(jwtDecoded.exp);
        document.cookie = `account-button=${
          jwtDecoded.givenName
        } ${jwtDecoded.familyName
          .substr(0, 1)
          .toUpperCase()}; expires=${expirationCookie}; path=/`;
      } else if (!isLoggedIn) {
        console.log("else if !isLoggedIn");
        localStorage.removeItem("ACCESS_TOKEN");
        localStorage.removeItem("REFRESH_TOKEN");
        localStorage.removeItem("CONTACT_USER");
        localStorage.removeItem("CONTACT");
        localStorage.removeItem("IS_LOGGED_IN");

        // on enlève le cookie avec le nom du user dans le bouton accès adhérent
        document.cookie = `account-button=;  expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;

        this.setState({ isLoggedIn });
      } else {
        console.log("will set the login status to ", isLoggedIn);
        this.setState({ isLoggedIn });
      }
    },
    isUserLoggedIn: () => {
      return this.state.isLoggedIn;
    },

    getContactFromUser: async (userId) => {
      try {
        const response = await Api.get(CONTACT_USER_ENDPOINT + userId);
        const { data } = response;

        if (response.status === 200) {
          this.setState({ contactUser: data });
          await localStorage.setItem("CONTACT_USER", JSON.stringify(data));
        } else {
          // alert("error");
          console.error(data);
          this.setState({ errorOccurred: true });
        }
      } catch (reason) {
        console.log("getContactFromUserError", reason, reason.response);
        if (reason.response) {
          if (reason.response.status === 400) {
            this.setState({ error: "Identifiants inconnus" });
          } else if (reason.response.status === 401) {
            console.log("Invalid JWT");
            this.state.setLoginStatus(false);
          } else {
            this.setState({ error: "Une erreur s'est produite" });
          }
        }
      }
    },

    getContact: async () => {
      const contactId = this.state.contactUser.contactId.split(
        `/${CLIENT_TOKEN}contacts/`
      )[1];

      try {
        const response = await Api.get(CONTACT_ENDPOINT + contactId);

        const { data } = response;

        await this.setState({ contact: data });
        await localStorage.setItem("CONTACT", JSON.stringify(data));
      } catch (reason) {
        console.log("getContactError", reason);
        if (reason.response) {
          if (reason.response.status === 400) {
            this.setState({ error: "Identifiants inconnus" });
          } else {
            this.setState({ error: "Une erreur s'est produite" });
          }
        }
      }
    },

    mandates: null,

    addMandate: async (mandate) => {
      const contact = this.state.contact;

      if (this.state.loading.mandates) return;

      const loading = { ...this.state.loading };
      loading.mandates = true;
      this.setState({ loading });
      const date = new Date().toISOString().split("T")[0];
      try {
        const response = await Api.post("mandates", {
          contactId: this.state.contact["@id"],
          contactNumber: this.state.contact.number,
          contactGivenName: this.state.contact.givenName,
          contactFamilyName: this.state.contact.familyName,
          contactAddress: {
            streetAddress: contact.address.streetAddress,
            postalCode: contact.address.postalCode,
            addressLocality: contact.address.addressLocality,
            addressCountry: contact.address.addressCountry,
          },
          holder: mandate.holder,
          iban: mandate.iban,
          bic: mandate.bic,
          validFrom: date,
          corporation: null,
        });

        const loading = { ...this.state.loading };
        loading.mandates = false;
        let { data } = response;
        console.log(response);

        if (data["hydra:member"]) {
          await this.setState({ mandates: data["hydra:member"], loading });
          return response;
        } else {
          this.setState({ mandates: [], loading });
        }
      } catch (reason) {
        if (reason.response) {
          const loading = { ...this.state.loading };
          loading.mandates = false;
          if (reason.response.status === 400) {
            return reason.response;
          } else {
            return reason.response;
          }
        }
      }
    },

    getMandates: async () => {
      const contact = this.state.contactUser;

      if (this.state.loading.mandates) return;

      const loading = { ...this.state.loading };
      loading.mandates = true;
      this.setState({ loading });
      try {
        const response = await Api.get("mandates", {
          params: {
            contactId: contact.contactId,
          },
          headers: {
            ...DEFAULT_HEADERS,
          },
        });
        const loading = { ...this.state.loading };
        loading.mandates = false;
        let { data } = response;
        console.log(response);

        if (data["hydra:member"]) {
          this.setState({ mandates: data["hydra:member"], loading });
        } else {
          this.setState({ mandates: [], loading });
        }
      } catch (reason) {
        if (reason.response) {
          const loading = { ...this.state.loading };
          loading.mandates = false;
          if (reason.response.status === 400) {
            this.setState({ error: "Identifiants inconnus", loading });
          } else {
            this.setState({ error: "Une erreur s'est produite", loading });
          }
        }
      }
    },

    // Produits
    products: [],
    // Si on a quitté la popup, on recup dans le store les produits fetchés la 1ère fois
    setProductsToList: (productKey, products) => {
      this.setState({ [productKey]: products });
    },

    setCoursCoProducts: (coursCoVisio, coursCoMonStade, coursCoMixte) => {
      this.setState({ coursCoVisio, coursCoMonStade, coursCoMixte });
    },

    /******************************************************************************************************/
    /******************************************************************************************************/
    /************ PLANNING LOGIC PART  ********************************************************************/
    /******************************************************************************************************/
    /******************************************************************************************************/
    // Planning
    currentReservationId: null,
    dateRange: dayjs(),
    goToNextWeek: () => {
      const newWeek = dayjs(this.state.dateRange).add(1, "w");
      this.setState({ dateRange: newWeek });
    },

    goToPreviousWeek: () => {
      const previousWeek = dayjs(this.state.dateRange).subtract(1, "w");
      if (previousWeek.isBefore(dayjs(), "day")) {
        return;
      }

      this.setState({ dateRange: previousWeek });
    },
    setCurrentReservationId: (id) => {
      this.setState({ currentReservationId: id });
    },

    // contient la liste des studios qu'on utilise pour filtrer les elements du planning (on affiche que les events des studios passés en param)
    // on les stocke dans le Provider pour que le component Slotbooking y ait accès quand il refreshe les cours, après qu'on se soit inscrit/désincrit d'un cours
    calendars: [],
    setCalendars: (calendars) => {
      this.setState({ calendars });
    },
    activities: null,
    coaches: null,
    studios: null,
    class_events: null,
    // Tableau de 6 entrées (du lundi au samedi)
    // avec un tableau par jour pour la liste des events
    // et encore 4 tableau pour les 4 créneaux journaliers --> Matin, midi, après midi, soir
    class_eventSorted: [
      // Lundi
      [[], [], [], []],
      // Mardi
      [[], [], [], []],

      [[], [], [], []],
      [[], [], [], []],
      [[], [], [], []],
      [[], [], [], []]
    ],

    replaceActivityName: async () => {
      if (this.state.class_events && this.state.class_events !== null) {
        const events = this.state.class_events.map((event) => {
          event.activityName = "Activité inconnue";
          if (this.state.activities) {
            this.state.activities.map((activity) => {
              if (event.activity === activity["@id"]) {
                event.activityName = activity.name;
              }
            });
          }

          event.coachGivenName = "";
          event.coachFamilyName = "";
          if (this.state.coaches) {
            this.state.coaches.map((coach) => {
              if (event.coach === coach["@id"]) {
                event.coachGivenName = coach.givenName;
                event.coachFamilyName = coach.familyName;
              }
            });
          }
          event.studioName = "";
          if (this.state.studios) {
            this.state.studios.map((studio) => {
              if (event.studio === studio["@id"]) {
                event.studioName = studio.name;
              }
            });
          }

          return event;
        });
      }
    },
    checkAttendees: async () => {
      const contact = await JSON.parse(localStorage.getItem("CONTACT"));
      const events = Array.from(this.state.class_events);
      events.map((event) => {
        if (event.bookedAttendees.length === 0) {
          event.attending = false;
        } else {
          event.bookedAttendees.map((attendee) => {
            if (attendee.contactId === contact["@id"]) {
              event.attending = true;
            }
          });
        }

        if (event.queuedAttendees.length === 0) {
          event.isUserInQueue = false;
        } else {
          event.queuedAttendees.map((attendee) => {
            if (attendee.contactId === contact["@id"]) {
              event.isUserInQueue = true;
            }
          });
        }
      });

      console.log("EVEEEEENTS", events);
      this.setState({ class_events: events });
    },

    sortClassEvents: () => {
      // Tableau de 6 entrées (du lundi au samedi)
      // avec un tableau par jour pour la liste des events
      // et encore 4 tableau pour les 4 créneaux journaliers --> Matin, midi, après midi, soir
      const eventsByDay = [
        // Lundi
        [[], [], [], []],
        // Mardi
        [[], [], [], []],

        [[], [], [], []],
        [[], [], [], []],
        [[], [], [], []],
        [[], [], [], []],
      ];
      if (!this.state.class_events) {
        return;
      }

      this.state.class_events
          .sort((a, b) =>
              dayjs(a.startedAt).isAfter(dayjs(b.startedAt)) ? 1 : -1
          )
          .map((item) => {
            // On définit le 1er jour de la semaine
            const weekFirstDay = this.state.dateRange.weekday(0);

            for (let i = 0; i < 6; i++) {
              // weekFirstDay.weekday(i) utilise la locale FR donc weekFirstDay.weekday(0) correspond au lundi, premier jour de la semaine
              if (dayjs(item.startedAt).isSame(weekFirstDay.weekday(i), "day")) {
                if (
                    this.state.getTimeRange(item.startedAt) === timeRanges.MORNING
                ) {
                  // 0 is for morning
                  eventsByDay[i][0].push(item);
                } else if (
                    this.state.getTimeRange(item.startedAt) === timeRanges.NOON
                ) {
                  // 1 is for noon
                  eventsByDay[i][1].push(item);
                } else if (
                    this.state.getTimeRange(item.startedAt) === timeRanges.AFTERNOON
                ) {
                  // 2 is for afternoon
                  eventsByDay[i][2].push(item);
                } else if (
                    this.state.getTimeRange(item.startedAt) === timeRanges.EVENING
                ) {
                  // 3 is for evening
                  eventsByDay[i][3].push(item);
                }
                // eventsByDay[i].push(item);
              }
            }
          });
      // console.log(eventsByDay);
      this.setState({ class_eventSorted: eventsByDay });
    },

    getRessources: async (resource, params = {}) => {
      const response = await axios
        .get(LOCAL_API + resource, {
          params,
        })
        .catch((reason) => {
          console.log("yo", reason);
          if (reason.response) {
            if (reason.response.status === 400) {
              this.setState({ error: "Identifiants inconnus" });
            } else {
              this.setState({ error: "Une erreur s'est produite" });
            }
          }
        });
      if (response) {
        let { data } = response;

        if (data.status === 200) {
          this.setState({ [resource]: data.body });
        } else {
          // alert("error");
          console.error(data);
          this.setState({ errorOccurred: true });
        }

        console.log(resource, this.state);
      }
    },
    removeUnwantedActivitiesFromActivityList: async () => {
      if (this.state.activities) {
        return this.state.activities.reduce((arr, activity) => {
          if (!activitiesNotIncludedInClassEvents.includes(activity["@id"])) {
            arr.push(activity["@id"]);
            return arr;
          }
          return arr;
        }, []);
      }
      return [];
    },

    getClassEvents: async (params, fromStudio = false) => {
      let parameters = {
        "order[startedAt]": "asc",
        calendars: this.state.calendars,
        ...params,
      };

      if (!fromStudio) {
        const activities = await this.state.removeUnwantedActivitiesFromActivityList();
        parameters = await Object.assign({ activity: activities }, parameters);
      }
      if (typeof this._source != typeof undefined) {
        this._source.cancel("Operation canceled due to new request.");
      }
      this.setState({ loading: true });

      // save the new request for cancellation
      this._source = axios.CancelToken.source();
      const response = await axios
          .get(`${LOCAL_API}${fromStudio ? "events" : "class_events"}`, {
            params: parameters,
            cancelToken: this._source.token,
          })
          .catch((reason) => {
            if (axios.isCancel(reason)) {
              console.log("Request canceled", reason);
              return Promise.reject("eee");
            } else {
              console.log("yo", reason);
              if (reason.response) {
                if (reason.response.status === 400) {
                  this.setState({ error: "Identifiants inconnus" });
                } else {
                  this.setState({ error: "Une erreur s'est produite" });
                }
              }
            }
          });
      if (response) {
        if (response.data) {
          let { data } = response;

          if (data.status === 200) {
            this.setState({ ["class_events"]: data.body });

            await this.state.replaceActivityName();
            await this.state.sortClassEvents();
            if (this.state.isUserLoggedIn()) {
              await this.state.checkAttendees();
            }
            return new Error("unauthenticated");
          } else {
            // alert("error");
            console.error(data);
            this.setState({ errorOccurred: true });
          }
        }
      }
      // await this.getRessources("class_events", parameters);
    },

    /**
     *
     * Retourne la timeRange dans laquelle se trouve le ClassEvent (cours) pour lequel on a passé l'heure en paramètre.
     * Valeurs Possibles contenues dans l'objet timeRanges dans le fichier constants.js
     * @param {*} time
     * @returns
     * @memberof Day
     */
    getTimeRange: (time) => {
      if (dayjs(time).isBefore(dayjs(time).hour(12).minute(0))) {
        return timeRanges.MORNING;
      } else if (dayjs(time).isBefore(dayjs(time).hour(13).minute(30))) {
        return timeRanges.NOON;
      } else if (dayjs(time).isBefore(dayjs(time).hour(17).minute(28))) {
        return timeRanges.AFTERNOON;
      } else if (dayjs(time).isAfter(dayjs(time).hour(17).minute(29))) {
        return timeRanges.EVENING;
      }
    },

    //************************************************************************************************************************************* */
    //************************************************************************************************************************************* */
    // Sales
    //************************************************************************************************************************************* */
    //************************************************************************************************************************************* */
    cartId: null,

    createSale: async () => {
      try {
        const response = await Api.post(
          "sales",
          {
            contactId: this.state.contact["@id"],
            contactFamilyName: this.state.contact.familyName,
            contactGivenName: this.state.contact.givenName,
            contactNumber: this.state.contact.number,
            clubId: CLUB_ID,
            checkoutId: MONSTADE_CHECKOUT_ID,
            clubCode: CLUB_CODE,
            channel: "web",
            address: {
              addressCountry: this.state.contact.address.addressCountry,
              addressLocality: this.state.contact.address.addressLocality,
              postalCode: this.state.contact.address.postalCode,
              streetAddress: this.state.contact.address.streetAddress,
            },
          },
          {
            headers: {
              // ...DEFAULT_HEADERS
            },
          }
        );

        const { data } = response;
        console.log(response);

        return { sale: data, error: null };
      } catch (reason) {
        console.log("reason", reason);
        if (reason.response) {
          if (reason.response.status === 400) {
            return { error: "Identifiants inconnus" };
          } else {
            return { error: "Une erreur s'est produite" };
          }
        }
      }
    },

    addProductToSale: async (offer, startDate = null) => {
      const saleId = this.state.cartId.split("/monstade/sales/")[1];

      const postParams = {
        offerId: offer["@id"],
        implementation: {},
        repaymentSchedule: {},
      };
      // Si de type abonnement, on ajoute le startDate
      // if (product.type === "subscription"){
      const today = new Date().toISOString().split("T")[0];
      postParams.implementation.startDate = (startDate !== null) ? startDate : today;
      // }

      if (offer.initialBilling) {
        postParams.repaymentSchedule.startDate = (startDate !== null) ? startDate : today;
      }

      try {
        const response = await Api.post(
          "sales/" + saleId + "/articles",
          postParams
        );

        const { data } = response;
        console.log(response);

        return { sale: data, error: null };
      } catch (reason) {
        if (reason.response) {
          if (reason.response.status === 400) {
            return { error: "Identifiants inconnus" };
          } else {
            return { error: "Une erreur s'est produite" };
          }
        }
      }
    },

    /**
     * On récupère les ventes associés au user créées entre hier et aujourd'hui
     *
     */
    getActiveSales: async () => {
      const today = new Date().toISOString().split("T")[0];
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow = tomorrow.toISOString().split("T")[0];

      try {
        const response = await Api.get("sales", {
          params: {
            contactId: this.state.contactUser.contactId,
            clubId: CLUB_ID,
            state: "cart",
            "createdAt[after]": today,
            "createdAt[before]": tomorrow,
          },
        });
        const { data } = response;
        console.log(response);

        if (data["hydra:member"])
          return { sales: data["hydra:member"], error: null };
        else return { error: null, sales: [] };
      } catch (reason) {
        if (reason.response) {
          if (reason.response.status === 400) {
            return { error: "Identifiants inconnus" };
          } else {
            return { error: "Une erreur s'est produite" };
          }
        }
        return { error: "Une erreur s'est produite" };
      }
    },

    getUserCart: async (createCart = true) => {
      // On récupère les ventes en cours
      const result = await this.state.getActiveSales();
      const { sales } = result;
      if (result.error) {
        // TODO Handle error
      } else {
        if (sales && sales.length === 0) {
          if (createCart) {
            const sale = await this.state.createSale();
            if (sale.error === null) {
              console.log("sales", sale);
              await this.setState({ cartId: sale.sale["@id"] });
            }
          }
          // TODO handle Error
        } else if (sales && sales.length > 0) {
          // on retourn le dernier panier actif (normalement ordered par date de création)
          await this.setState({ cartId: sales[sales.length - 1]["@id"] });
          return sales[sales.length - 1];
        }
      }
    },

    // Custom program - Programmes personnalisés
    popupCustomProgram: false,

    getCustomPrograms: async (resource, params = {}) => {
      const response = await axios
        .get(LOCAL_API + "custom-programs")
        .catch((reason) => {
          this.setState({ error: "Une erreur s'est produite" });
        });
      if (response) {
        let { data } = response;
        this.setState({ customProgramRules: data });
      }
    },
    getCombinationProductRules: async (resource, params = {}) => {
      const response = await axios
        .get(LOCAL_API + "combination-rules")
        .catch((reason) => {
          this.setState({ error: "Une erreur s'est produite" });
        });
      if (response) {
        let { data } = response;
        this.setState({ combinationProductRules: data });
      }
    },
  };

  render() {
    return (
      /**
       * la propriété value est très importante ici, elle rend
       * le contenu du state disponible aux `Consumers` de l'application
       */
      <Context.Provider value={this.state}>
        {this.props.children}
      </Context.Provider>
    );
  }
}

export default Provider;
